import axios from 'axios'
import { ElMessage, ElMessageBox } from 'element-plus'

const REDIRECT_DELAY_MS = 80
const REDIRECT_LOCK_MS = 1200

let redirecting = false
let navigationTimer = null
let releaseTimer = null

export function isAuthRedirecting() {
  return redirecting
}

export function clearAuthSession() {
  localStorage.removeItem('token')
  localStorage.removeItem('userInfo')
  localStorage.removeItem('userId')

  axios.defaults.headers.common.Authorization = ''

  if (typeof window !== 'undefined' && window.autoLogoutTimer) {
    clearTimeout(window.autoLogoutTimer)
    window.autoLogoutTimer = null
  }
}

function releaseRedirectLock() {
  if (typeof window === 'undefined') {
    redirecting = false
    return
  }

  if (releaseTimer) {
    clearTimeout(releaseTimer)
  }

  releaseTimer = window.setTimeout(() => {
    redirecting = false
  }, REDIRECT_LOCK_MS)
}

function cleanupTransientUi() {
  ElMessageBox.close()
  ElMessage.closeAll()

  if (typeof document === 'undefined') {
    return
  }

  document.body.classList.remove('el-popup-parent--hidden')
  document.body.style.removeProperty('overflow')
  document.body.style.removeProperty('padding-right')

  document
    .querySelectorAll('.el-overlay, .el-overlay-dialog, .el-overlay-message-box, .el-message-box, .el-message-box__wrapper')
    .forEach(node => node.remove())
}

function showRedirectMessage(message, messageType) {
  if (!message) {
    return
  }

  const type = typeof ElMessage[messageType] === 'function' ? messageType : 'error'
  ElMessage[type](message)
}

export function redirectToLogin(router, options = {}) {
  const {
    message = '登录已过期，请重新登录',
    messageType = 'error',
  } = options

  clearAuthSession()
  cleanupTransientUi()

  const currentPath = router?.currentRoute?.value?.path || window.location.pathname
  const isOnLoginPage = currentPath === '/login'

  if (redirecting) {
    releaseRedirectLock()
    return
  }

  redirecting = true

  if (!isOnLoginPage) {
    showRedirectMessage(message, messageType)
  }

  if (navigationTimer) {
    clearTimeout(navigationTimer)
  }

  if (!router) {
    if (!isOnLoginPage) {
      window.location.assign('/login')
    }
    releaseRedirectLock()
    return
  }

  if (isOnLoginPage) {
    releaseRedirectLock()
    return
  }

  navigationTimer = window.setTimeout(() => {
    router.replace('/login')
      .catch(error => {
        console.error('跳转登录页失败:', error)
      })
      .finally(() => {
        releaseRedirectLock()
      })
  }, REDIRECT_DELAY_MS)
}
